// OutsideClickDirective.js
const OutsideClickDirective = {
    beforeMount(el, binding) {
        const handleOutsideClick = (e) => {
            if (!el.contains(e.target) && el !== e.target) {
                binding.value();
            }
        };
        el.__vueClickOutside__ = handleOutsideClick;
        document.addEventListener("click", handleOutsideClick);
    },
    unmounted(el) {
        document.removeEventListener("click", el.__vueClickOutside__);
        delete el.__vueClickOutside__;
    },
};

export default OutsideClickDirective;
